<!-- <div style="display:flex">
    <ng-container *ngIf="isSet">
        <div class="master-container" style="flex:3">
            <ubs-list-container [state]="state" [listForms]="listForms" [addForms]="addForms" [incomingLink]="incomingLink"></ubs-list-container>
        </div>
    </ng-container>
    <div class="detail-container" style="flex:2">
        <ng-container *ngIf="selectedValue;else noSelected">
            <ubs-edit-container [state]="state" [activeLevel]="activeLevel" [addForms]="addForms" [action]="action" [relations]="relations"></ubs-edit-container>
        </ng-container>
        <ng-template #noSelected>
            <div class="empty-message">
                <p>Nothing selected</p>
                <p>Select an item from the list.</p>
            </div>
        </ng-template>
    </div>
</div> -->
<div class="master-detail-container">
    <div class="master-container" style="flex:2">
        <ng-container *ngIf="isSet">
            <ubs-relation-list-container [listForm]="listForm" [parameters]="parameters" [title]="listContainerTitle" [addForm]="addForm" [appContext]="appContext"></ubs-relation-list-container>
        </ng-container>
    </div>
    <div class="detail-container" style="flex:2">
        <ng-container *ngIf="isListDetail;else addFormContainer">
            <ng-container *ngIf="selectedValue;else noSelected">
                <ubs-detail-list-container [listForm]="listDetail" [parameters]="detailListFindParameters" [title]="detailListContainerTitle" [addForm]="addForm" [appContext]="appContext"></ubs-detail-list-container>
                <!-- <ubs-relation-list-container [listForm]="listDetail" [parameters]="parameters" [title]="addContainerTitle" [addForm]="addForm" [appContext]="appContext"></ubs-relation-list-container> -->
            </ng-container>
        </ng-container>
        <ng-template #addFormContainer>
            <ng-container *ngIf="selectedValue;else noSelected">
                <ubs-relation-form-container [addForm]="addForm" [parameters]="parameters" [selectedValue]="selectedValue" [addContainerTitle]="addContainerTitle" [lookupFieldResult]="lookupFieldResult" [appContext]="appContext" (refreshList)="refreshRelatedLists($event)"></ubs-relation-form-container>
            </ng-container>
        </ng-template>
        <ng-template #noSelected>
            <div class="empty-message">
                <p>Nothing selected</p>
                <p>Select an item from the list.</p>
            </div>
        </ng-template>


        <!-- <ng-container *ngIf="selectedValue;else noSelected">
            <ng-container *ngIf="isListDetail;else addFormContainer">
                
            </ng-container>
            <ng-template #addFormContainer>
                <ubs-relation-form-container [addForm]="addForm" [parameters]="parameters" [selectedValue]="selectedValue" [addContainerTitle]="addContainerTitle" [lookupFieldResult]="lookupFieldResult" [appContext]="appContext" (refreshList)="refreshRelatedLists($event)"></ubs-relation-form-container>
            </ng-template>
        </ng-container> -->
        
    </div>
</div>


<!-- <ubs-relation-form-container [addForm]="addForm" [parameters]="parameters" [title]="addContainerTitle" [lookupFieldResult]="lookupFieldResult" [appContext]="appContext" (refreshList)="refreshRelatedLists($event)"></ubs-relation-form-container> -->
